import logo from '../../themes/controdata/logo.svg'
import favicon from '../../themes/controdata/favicon.svg'
import home from '../../themes/controdata/home.svg'

const controdata = {
    homeBackgroundImage : home,
    logo: logo,
    favicon : favicon,
    homeWelcomeMessageColor: '#445462',
    homeLabelColor: '#7C838A',
    homePlaceHolderColor: "#7b7f81",
    homeBackgroundColorButton: "#F42626",
    homeBackgroundColorInput : "#dde2e7",
    fontFamily: 'Open Sans", "Montserrat", sans-serif',
    sidebarBackgroundColor: '#2085A4',
    navbarBackgroundColor: '#2085A4',
    footerBackgroundColor: '#2085A4',
    environments: {
            production: {
            baseUrl: "https://controdata.com.br",
            enableLogs: false,
        },
            homolog: {
            baseUrl: "http://localhost:3004",
            enableLogs: true,
        },
            development: {
            baseUrl: "http://localhost:3004",
            enableLogs: true,
        }
    },
    versionName: "1.3.3"
};

export default controdata;
